module.exports = __webpack_public_path__ + "img/MapThumb_TreasureIsland.9e26c5a5.webp";